import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/cn';

type Props = {
  menuOpen: boolean;
  onOpenMenu: () => void;
};

const primary = [
  { to: '/dashboard', label: '首页', icon: 'fa-solid fa-house', end: true },
  { to: '/entries', label: '登记', icon: 'fa-solid fa-inbox', end: true },
  { to: '/sites', label: '站点', icon: 'fa-solid fa-globe', end: false },
] as const;

function moreSectionActive(pathname: string): boolean {
  return (
    pathname === '/settings' ||
    pathname === '/wechat' ||
    pathname === '/interfaces' ||
    pathname === '/help' ||
    pathname === '/log-center' ||
    pathname === '/login-logs' ||
    pathname === '/users'
  );
}

export function MobileTabBar({ menuOpen, onOpenMenu }: Props) {
  const { pathname } = useLocation();
  const moreActive = moreSectionActive(pathname);

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 border-t border-slate-200/80 bg-white/90 shadow-[0_-8px_32px_rgba(15,23,42,0.08)] backdrop-blur-xl md:hidden"
      style={{ paddingBottom: 'max(0.35rem, env(safe-area-inset-bottom))' }}
      role="navigation"
      aria-label="主导航"
    >
      <div className="mx-auto flex max-w-7xl items-stretch justify-around px-0.5">
        {primary.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              cn(
                'flex min-h-[3.35rem] min-w-0 flex-1 touch-manipulation flex-col items-center justify-center gap-0.5 px-0.5 py-1 transition-colors active:bg-slate-50/90',
                isActive ? 'text-teal-600' : 'text-slate-500'
              )
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={cn(
                    'flex h-8 w-8 items-center justify-center rounded-xl transition-colors',
                    isActive ? 'bg-teal-50' : 'bg-transparent'
                  )}
                >
                  <i
                    className={cn('text-[1.05rem]', item.icon, isActive ? 'text-teal-600' : 'text-slate-500')}
                    aria-hidden
                  />
                </span>
                <span className="max-w-full truncate text-[11px] font-medium leading-tight">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={onOpenMenu}
          className={cn(
            'flex min-h-[3.35rem] min-w-0 flex-1 touch-manipulation flex-col items-center justify-center gap-0.5 px-0.5 py-1 transition-colors active:bg-slate-50/90',
            menuOpen || moreActive ? 'text-teal-600' : 'text-slate-500'
          )}
          aria-label="打开更多菜单"
          aria-expanded={menuOpen}
        >
          <span
            className={cn(
              'flex h-8 w-8 items-center justify-center rounded-xl transition-colors',
              menuOpen || moreActive ? 'bg-teal-50' : 'bg-transparent'
            )}
          >
            <i
              className={cn(
                'text-[1.05rem] fa-solid fa-bars',
                menuOpen || moreActive ? 'text-teal-600' : 'text-slate-500'
              )}
              aria-hidden
            />
          </span>
          <span className="text-[11px] font-medium leading-tight">更多</span>
        </button>
      </div>
    </nav>
  );
}
